import { Component, type ErrorInfo, type ReactNode } from 'react'
import { reportError } from '@/shared/infra/observability'
import { ErrorBoundaryFallback } from './error-boundary-fallback'

type ErrorBoundaryProps = {
  children: ReactNode
  fallback?: (error: Error, reset: () => void) => ReactNode
}

type ErrorBoundaryState = {
  error: Error | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError(error, { context: { componentStack: info.componentStack } })
  }

  reset = (): void => {
    this.setState({ error: null })
  }

  render(): ReactNode {
    if (this.state.error === null) return this.props.children
    if (this.props.fallback) return this.props.fallback(this.state.error, this.reset)
    return <ErrorBoundaryFallback onReload={() => window.location.reload()} />
  }
}
